{
  "id": "campaign-136",
  "name": "Home Stadium",
  "seed": "campaign:136",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "...:........:,..",
    ".#.:........:,..",
    "..#::::::::::...",
    "................",
    "..,a........a.x.",
    ".,,,q....#.q....",
    "..,.............",
    "................",
    "::::::::::::::::",
    "...,......~~.~..",
    "..q,,....~,.~q..",
    "..a,.....,,,.a..",
    "......a..a,.....",
    "...::::::::::...",
    "..a:.a....a.:a..",
    "...:........:...",
    "......QQQQ.....S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 5,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 16
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 13,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 9
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 0
    },
    {
      "kind": "repair",
      "x": 15,
      "y": 7
    }
  ],
  "balls": {
    "first": 18,
    "every": 12
  },
  "generatorVersion": 3,
  "level": 136,
  "biome": "stadium",
  "par": {
    "reel": 9998,
    "push": 8627,
    "selfPropelled": 7692,
    "tractor": 6390,
    "zeroTurn": 5676,
    "fairway": 2963
  },
  "goldTime": {
    "reel": 9698,
    "push": 8484,
    "selfPropelled": 7680,
    "tractor": 6380,
    "zeroTurn": 5489,
    "fairway": 2833
  },
  "routeTries": {
    "par": {
      "reel": 13,
      "push": 10,
      "selfPropelled": 21,
      "tractor": 0,
      "zeroTurn": 18,
      "fairway": 5
    },
    "gold": {
      "reel": 35,
      "push": 43,
      "selfPropelled": 35,
      "tractor": 25,
      "zeroTurn": 37,
      "fairway": 47
    }
  }
}
